import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import { connect } from 'react-redux';

import * as ProductionReportSetupSelectors from '../state/selectors';
import { Pages } from '../helpers/Constants';
import { SelectTemplatePage } from './SelectTemplatePage';
import { AssignMenuMealTypePage } from './AssignMenuMealTypePage';
import { withReportSubscription } from 'State/report/withReportSubscription';

class CreateProductionReportModalForm extends Component {
    render() {
        const { page } = this.props;

        return (
            <Form>
                {page === Pages.SelectTemplate && <SelectTemplatePage />}
                {page === Pages.AssignMenuMealType && <AssignMenuMealTypePage />}
            </Form>
        );
    };
}

const mapStateToProps = state => {
    return {    
        page: ProductionReportSetupSelectors.getPage(state),
    };
};
    
CreateProductionReportModalForm = withReportSubscription(CreateProductionReportModalForm);

CreateProductionReportModalForm = connect(
    mapStateToProps
)(CreateProductionReportModalForm);

export { CreateProductionReportModalForm };


// WEBPACK FOOTER //
// ./src/pages/productionreportsetup/subpages/CreateProductionReportModalForm.js